export const zipCodeForPointsRelais = pointsRelais => {
  if (!pointsRelais) return [];
  const newPointsRelais = pointsRelais.map(point => {
    const stringZipCode = point.codePostal.toString();
    if (stringZipCode.length === 4) {
      const newZipCode = stringZipCode.padStart(5, '0');
      return { ...point, codePostal: newZipCode };
    }
    return point;
  });
  return newPointsRelais;
};
